import { TaxonomyChildrenSortField, TaxonomyChildrenSortOrder } from 'generated/graphql'
import type { TDatadogErrorLog } from 'utils/datadog/types'

export const TAXONOMY_CHILDREN_PAGE_SIZE = 10

export const TAXONOMY_CHILDREN_TOTALS_CONCURRENCY = 5

export const TAXONOMY_CHILDREN_SORT = {
  sortField: TaxonomyChildrenSortField.TotalChildren,
  sortOrder: TaxonomyChildrenSortOrder.Desc,
}

export const GET_TERRITORY_CHILDREN_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/taxonomy-children-tab/taxonomy-children-tab.utils.ts',
  name: 'Get territory children',
  message: 'Fetch a page of the children of a global taxonomy territory',
}

export const LIST_TERRITORIES_TOTALS_LOG: TDatadogErrorLog = {
  from: 'src/modules/niche/taxonomy-children-tab/taxonomy-children-tab.utils.ts',
  name: 'List territories totals',
  message: 'Fetch the totals of a global taxonomy child',
}
